/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { catchError, Observable, throwError, tap } from 'rxjs'
import { SnackBarService } from '../snackbar.service'
import { SILENT_ERROR_STATUSES } from './http-context-tokens'

/**
 * List of URLs to be excluded from certain operations, such as displaying success messages in an HTTP interceptor.
 */
// const skipUrlList = ['dashboard', 'software', 'scan-results']

/**
 * Intercepts HTTP requests and handles errors and success messages.
 *
 * This interceptor is designed to:
 * - Display success messages for successful requests, excluding specific URLs.
 * - Display error messages for failed requests.
 * - Re-throw errors to be handled by the application.
 *
 * @param req The HTTP request to be intercepted.
 * @param next The next handler in the request pipeline.
 * @returns An Observable of the HTTP event.
 */
export function ApiInterceptor(
    req: HttpRequest<any>,
    next: HttpHandlerFn
): Observable<HttpEvent<any>> {
    const snackbarService = inject(SnackBarService)

    // const isSkipped = skipUrlList.find((value) => req.url.includes(value)) ? true : false

    return next(req).pipe(
        tap((_evt) => {
            // if (evt instanceof HttpResponse && evt.status === 200 && !isSkipped) {
            //     snackbarService.showSuccess('Success')
            // }
        }),
        catchError((err: HttpErrorResponse) => {
            const silentStatuses = req.context.get(SILENT_ERROR_STATUSES)
            if (!silentStatuses.includes(err.status)) {
                // err.error can be a bare string (BadRequestObjectResult(string) on the backend)
                // instead of an {error/title/message} object — same fix as ErrorInterceptor.
                const bodyMessage =
                    typeof err.error === 'string'
                        ? err.error
                        : err.error?.error || err.error?.title || err.error?.message
                snackbarService.showError(bodyMessage || err.message || err.toString())
            }
            return throwError(() => err)
        })
    )
}
